<div class="description-data kb-focusable" tabindex="0">
	<h4 class="font-bold text-base">{{getHeader()}}</h4>
</div>

<simple-table
	[tableData]="data"
	tableClass="mt-16 stats-table-data table table-bordered"
	[descriptionId]="showDescription && widget.description ? 'widget-description-' + widget.id : undefined">
</simple-table>
